import { getActionAuthorization } from '../commons/utils';

const SALES_PLANNING_ACTIONS = {
  VIEW: 'forecast:forecast:sales-planning:view',
  EDIT: 'forecast:forecast:sales-planning:edit',
};

export const canViewSalesPlanning = (actions) =>
  getActionAuthorization(actions, SALES_PLANNING_ACTIONS.VIEW);

export const canEditSalesPlanning = (actions) =>
  getActionAuthorization(actions, SALES_PLANNING_ACTIONS.EDIT);
